import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input, SelectableBlock } from '../../../Elements';
import styles from './TermsBuilder.scss';
import Option from './Option';

const PaymentMethods = ({ checkboxChange, contractVariables, textFieldChange }) => {
  const defaultPaymentMethods = [
    { label: 'Cash', value: 'cash' },
    { label: 'Check', value: 'check' },
    { label: 'Credit Card', value: 'credit card' }
  ];
  return (
    <div>
      <h3>What payment methods do you accept?</h3>
      <br />
      {defaultPaymentMethods.map((method, index) => (
        <Option key={index}>
          <SelectableBlock
            name='paymentMethods'
            label={method.label}
            value={method.value}
            content={method.label}
            checkbox
            checked={contractVariables.paymentMethods.includes(method.value)}
            onChange={checkboxChange}
          />
        </Option>
      ))}
      <h3>How many days prior to the event is the full balance due?</h3>
      <Input
        className={styles.inlineField}
        name='paymentDaysBefore'
        type='number'
        inline
        required
        validationError='Required'
        value={contractVariables.paymentDaysBefore}
        onChange={textFieldChange}
      />
      <div className={styles.inlineFieldLabel}>days</div>
    </div>
  );
};

PaymentMethods.propTypes = {
  checkboxChange: PropTypes.func.isRequired,
  contractVariables: PropTypes.object.isRequired,
  textFieldChange: PropTypes.func.isRequired
};

export default PaymentMethods;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/PaymentMethods.js